module.exports = __webpack_public_path__ + "img/juggernaut.a72b7f68.jpg";